import MainTitle from '../common/MainTitle';
import ImageLink from '../../js/utils/ImageLink';

export default function IntroSection({ data, image1, image2 }) {
  return (
    <section className="intro-section">
      <div className="intro-section__wrapper">
        {image1 && (
          <div className="intro-section__media">
            <picture>
              <source srcSet={ImageLink(image1?.url)} type="image/webp" />
              <img src={ImageLink(image1?.url)} alt={image1?.alt} />
            </picture>
          </div>
        )}

        <MainTitle type="dark" className="text--2xl hidden--lg">
          <span>{data.title1}</span>
          <span className="decorated-line decorated-line--dark decorated-line--left">
            {data.title2}
          </span>
        </MainTitle>

        <div className="intro-section__content">
          <MainTitle type="dark" className="text--2xl hidden--md">
            <span>{data.title1}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {data.title2}
            </span>
          </MainTitle>
        </div>
      </div>
    </section>
  );
}
